
// import React, { useEffect, useState } from "react";
// import "./ProductNew.css";
// import { Link } from "react-router-dom";
// import axios from "axios";

// function ProductNew() {
//   const [Product, setProduct] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
//       );
//       const data = response.data.data.slice(0,4);
//       setProduct(data);
//     };

//     fetchData();
//   }, []);

//    // Limit HTML content by characters
// const limitHTML = (html, limit) => {
//   const div = document.createElement("div");
//   div.innerHTML = html;
//   const text = div.innerText;

//   if (text.length <= limit) return html;

//   const trimmed = text.substring(0, limit) + "...";
//   return trimmed;
// };

//   return (
//     <>
//       <section className="service-section">
//         {/* Left Decorative Layer */}
//         <div className="container">
//           {/* Card Container */}
//           <h2 className="text-center">Products</h2>
//           <div className="service_contentbox horizontal-cards">
//             {/* Card 1 */}
//             {Product.map((Data, index) => (
//             <div className="service-box" key={index}>
//                 <img
//                   src={`https://cyberathon.com/NLF/${Data.pro_image}`}
//                   alt="Product Logo"
//                   className="img-fluid"
//                   style={{height:"150px", width:"100%"}}
//                 />
//               <h4>{Data.prod_heading}</h4>
//               <p className="text-size-18 three-line-limit">
//                 {Data.prod_paragraph}
//               </p>
//               <Link to={`/product/${Data.prod_id}`}>
//                 <i className="circle fa-thin fa-arrow-right" />
//               </Link>
//             </div>
//             ))}
//           </div>
//         </div>

//         {/* Right Dot Layer */}

//       </section>
//     </>
//   );
// }


// export default ProductNew;



// Nikita code
import React, { useEffect, useState } from "react";
import "./ProductNew1.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function ProductNew() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const handleViewMore = () => {
    navigate("/products");
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productRes, mainRes] = await Promise.all([
          axios.get(
            "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
          ),
          axios.get(
            "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_main_card"
          ),
        ]);

        // 🔹 Take first 3 products
        const productData = (productRes.data.data || [])
          .slice(0, 3)
          .map((item) => ({
            type: "product",
            id: item.prod_id,
            heading: item.prod_heading,
            image: item.pro_image,
            paragraph: item.prod_paragraph,
            link: `/product/${item.prod_id}`,
          }));

        // 🔹 Take 1 main card
        const mainCardData = (mainRes.data.data || [])
          .slice(0, 1)
          .map((item) => ({
            type: "mainCard",
            id: item.main_id,
            heading: item.name,
            image: item.image,
            paragraph: "", // no paragraph in main card
            link: `/subcard/${item.main_id}`,
          }));

        // 🔹 Merge total 4 cards
        const merged = [...productData, ...mainCardData];

        setProducts(merged);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="service-section">
        <div className="container">
          <h2 className="text-center pt-md-3 pt-0">Products</h2>

          <div className="service_contentbox horizontal-cards">
            {products.map((item, index) => (
              <div className="service-box" key={`${item.type}-${item.id}`}>
                <div className="product-image-wrapper">
                  <img
                    src={`https://cyberathon.com/NLF/${item.image}`}
                    alt={item.heading}
                    className="img-fluid"
                  // style={{ height: "150px", width: "100%", objectFit: "cover" }}
                  />
                </div>

                <h4>{item.heading}</h4>

                {/* Paragraph only for products */}
                {item.paragraph && (
                  <p className="text-size-18 three-line-limit">
                    {item.paragraph}
                  </p>
                )}

                <Link to={item.link}>
                  <i className="circle fa-thin fa-arrow-right" />
                </Link>
              </div>
            ))}
          </div>

          {/* <div className="d-flex justify-content-end align-items-center">
              <button
               className="rounded viewprod"
              
              onClick={()=>navigate("/products")}>
                View More

              </button>
            </div> */}
          <div className="d-flex justify-content-lg-end justify-content-center align-items-center">
            <button
              className="read_more viewprod"
              onClick={handleViewMore}
            >
              View More
              <figure className="mb-0">
                <img
                  src="about-img/button-arrow.png"
                  alt="arrow"
                  className="img-fluid"
                />
              </figure>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductNew;